import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Selectors from 'APP_ROOT/data/settings/selectors';
import { loadSettings, changeSetting } from 'APP_ROOT/data/settings/actions';
import ProgressOverlay from 'APP_ROOT/components/common/ProgressOverlay';
import { strings } from 'APP_ROOT/localization';

class UnitOfMeasure extends React.PureComponent {

    static propTypes = {
        stage: PropTypes.string.isRequired,
        changeUnitOfMeasure: PropTypes.func.isRequired,
        unitOfMeasureSetting: PropTypes.object
    }

    componentDidMount() {
        if (!this.props.settingsLoaded) {
            this.props.loadSettings();
        }
    }

    handleOptionChange = (event) => {
        this.props.changeUnitOfMeasure(event.target.value);
    };

    render() {
        const value = this.props.unitOfMeasureSetting ? this.props.unitOfMeasureSetting.value.toUpperCase() : undefined; // new accounts can have the value "Imperial" instead of "IMPERIAL" (RAV-3042 web app bug, RAV-3312 to correct the default setting in the get settings response)
        let pending = this.props.unitOfMeasureSetting ? this.props.unitOfMeasureSetting.pending : undefined;
        if (value === undefined) {
            pending = true;
        }
        return (
            <div>
                <h3>{strings.settings_unit_of_measure_header}</h3>
                <div>{strings.settings_unit_of_measure_description}</div>
                <div className='setting-group-horiz'>
                    <div className='setting-group radio-group'>
                        <div>
                            <input type="radio" name="unitOfMeasure" id="unitOfMeasure:imperial"
                                value='IMPERIAL'
                                checked={value === 'IMPERIAL'}
                                onChange={this.handleOptionChange}
                                disabled={pending}
                            />
                            <label htmlFor='unitOfMeasure:imperial' disabled={pending}>{strings.prefs_uom_imperial_long}</label>
                        </div>
                        <div>
                            <input type="radio" name="unitOfMeasure" id="unitOfMeasure:metric"
                                value='METRIC'
                                checked={value === 'METRIC'}
                                onChange={this.handleOptionChange}
                                disabled={pending}
                            />
                            <label htmlFor='unitOfMeasure:metric' disabled={pending}>{strings.prefs_uom_metric_long}</label>
                        </div>
                        { pending && <ProgressOverlay />}
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        settingsLoaded: Selectors.settingsLoaded(state),
        unitOfMeasureSetting: Selectors.getSetting(state, 'user.general.unitOfMeasure'),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        loadSettings: () => dispatch(loadSettings(ownProps.stage)),
        changeUnitOfMeasure: (value) => dispatch(changeSetting(ownProps.stage, 'user.general.unitOfMeasure', value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnitOfMeasure);